import { render } from "./BreadcrumbLink.vue?vue&type=template&id=626d749e&scoped=true&ts=true"
import script from "./BreadcrumbLink.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbLink.vue?vue&type=script&lang=ts"

import "./BreadcrumbLink.vue?vue&type=style&index=0&id=626d749e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626d749e"]])

export default __exports__